(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxOfficeDetailController', TaxOfficeDetailController);

    TaxOfficeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TaxOffice'];

    function TaxOfficeDetailController($scope, $rootScope, $stateParams, entity, TaxOffice) {
        var vm = this;
        vm.taxOffice = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:taxOfficeUpdate', function(event, result) {
            vm.taxOffice = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
